import { z } from 'zod';

export enum FileAction {
  NO_ACTION = 'NO_ACTION',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export const fileFieldSchema = z.object({
  file: z.instanceof(File).optional(),
  fileId: z.string().optional(),
  fileName: z.string().optional(),
  fileUrl: z.string().optional(),
  action: z.enum(FileAction).default(FileAction.NO_ACTION),
});

export const requiredFileFieldSchema = z.preprocess(
  (val) => val ?? {},
  fileFieldSchema.refine(
    (data) => {
      if (data.action === FileAction.DELETE) return false;
      return !!data.fileId || !!data.file;
    },
    { message: 'Plik jest wymagany' },
  ),
);

export type FileFieldData = z.infer<typeof fileFieldSchema>;
